import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";
import heroImage2 from "./assets/images/brainpathways2.png";
import heroImage1 from "./assets/images/brainpathways.png";

const App = () => {
  const [heroImage, setHeroImage] = useState(heroImage1);

  useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia("(max-width: 768px)").matches) {
        setHeroImage(heroImage1); // Mobile image
      } else {
        setHeroImage(heroImage2); // Non-mobile image
      }
    };

    handleResize(); // Call it initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Wrapper>
      <Header>
        <h1>
          <span className="neu">neu</span><span className="axon">axon</span>
        </h1>
        <p>Forging New Neural Pathways</p>
      </Header>

      <Main>
        <ImageContainer>
          <img src={heroImage} alt="Empowering young minds" />
        </ImageContainer>
        <h2>Coming Soon</h2>
        <p>
          Helping unique young minds soar with every tap, every swipe
        </p>
        <form>
          <input type="email" placeholder="Enter your email" />
          <button type="submit">Stay Updated</button>
        </form>
      </Main>

      <Footer>
        <SocialIcons>
          <a href="https://facebook.com"><FaFacebook /></a>
          <a href="https://twitter.com"><FaTwitter /></a>
          <a href="https://instagram.com"><FaInstagram /></a>
        </SocialIcons>
        <p>© {new Date().getFullYear()} neuaxon. All rights reserved.</p>
      </Footer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  font-family: 'Poppins', sans-serif;
  text-align: center;
  padding: 0 20px;
  color: #333;
`;

const Header = styled.header`
  margin: 50px 0;

  h1 {
    font-size: 4em;
    font-weight: 800;
    color: #01D0EF;
    line-height: 1;
    margin: 0; /* Remove default margin */
    padding: 0; /* Remove default padding */
    .neu {
      color: #FF5733; /* Color for "neu" */
    }

    .axon {
      color: #01D0EF; /* Color for "axon" */
    }
  }

  p {
    font-size: 1.19em;
    font-weight: 400;
    color: #490F23;
    margin: 0; /* Remove default margin */
  }
`;
const ImageContainer = styled.div`
  margin: 40px 0;
  img {
    max-width: 100%;
    height: auto;
    border-radius: 15px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
`;


const Main = styled.main`
  h2 {
    font-size: 1.35em;
    font-weight: 400;
    color: #490F23;
  }
  p {
    font-size: 1.19em;
    font-weight: 300;
    color: #490F23;
    margin: 20px 0;
  }
  form {
    margin: 20px 0;
    input {
      padding: 10px;
      width: 250px;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-right: 10px;
    }
    button {
      padding: 10px 20px;
      background: #01D0EF;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }
  }
`;

const Footer = styled.footer`
  margin-top: 50px;
  p {
    font-size: 0.9em;
    color: #999;
  }
`;

const SocialIcons = styled.div`
  margin-bottom: 10px;
  a {
    margin: 0 10px;
    color: #01D0EF;
    font-size: 1.5em;
    text-decoration: none;
  }
`;

export default App;


